module.exports = __webpack_public_path__ + "static/media/ownerfy-backpack-green-v3.c0566062.jpg";